import React, { memo, useEffect, useState } from 'react'

import { LightSelect, Button, SortIcon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  func, string, array, bool,
} from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import i18n from 'Pods/Shared/I18n'


function SortBy({
  sortByOptions,
  sortByValue = 'best_match',
  onSortChange,
  extractingCoreStyles,
  locale = 'en',
}) {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  function trackSortEvent(value = '') {
    if (window.customEventTracker) {
      window.customEventTracker({
        name: 'sorting_change',
        userId: window.pageConfig.currentUserId || '',
        eventData: {
          sorting_option: value,
        },
      })
    }
  }

  function handleSortChange({ value }) {
    const isDefaultValue = value === 'best_match'

    if (isDefaultValue) {
      trackSortEvent()

      return onSortChange({ name: 'sort_by', value: undefined })
    }

    trackSortEvent(value)

    return onSortChange({ name: 'sort_by', value })
  }

  function renderSelect() {
    const defaultLabel = i18n.t('listingPage.filters.sortBy.default', { ns: 'rails', lng: locale })

    const formattedSortByOptions = sortByOptions.map(({ value, label }) => {
      if (value === 'best_match') {
        return {
          value,
          label: (
            <div className="metaverse-listing__select-best-match">
              <span>{label}</span>
              <span className="metaverse-listing__default cgt-legacy-color-typography-disabled">{defaultLabel}</span>
            </div>
          ),
        }
      }

      return {
        value,
        label,
      }
    })

    const shouldRenderAnEmptyOption = (extractingCoreStyles || !isLoaded)

    return (
      <>
        {/* LightSelect's input does not forward aria-label, so associate a visually-hidden */}
        {/* <label> with its id to give the sort control an accessible name. The control lives */}
        {/* inside the third-party LightSelect, so the linter can't see the htmlFor target. */}
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="metaverse-sorting-option" className="metaverse-listing__visually-hidden">
          {i18n.t('listingPage.filters.sortBy.label', { ns: 'rails', lng: locale })}
        </label>
        <LightSelect
          isFullWidth
          onChange={handleSortChange}
          name="metaverse-sorting-option"
          id="metaverse-sorting-option"
          options={shouldRenderAnEmptyOption ? [{ value: '', label: '' }] : formattedSortByOptions}
          value={shouldRenderAnEmptyOption ? '' : sortByValue}
          menuClassName="metaverse-listing__select-menu"
        />
      </>
    )
  }

  return (
    <div className="metaverse-listing__select-new">
      <Button
        type="secondary"
        size="medium"
        variant="only-icon"
        icon={<SortIcon />}
        customClass="metaverse-listing__sort-by-button"
        aria-label={i18n.t('listingPage.filters.sortBy.label', { ns: 'rails', lng: locale })}
      />
      {renderSelect()}
    </div>
  )
}

SortBy.propTypes = {
  onSortChange: func.isRequired,
  sortByValue: string,
  sortByOptions: array.isRequired,
  extractingCoreStyles: bool.isRequired,
  locale: string,
}

const mapStateToProps = ({
  sortByOptions, sortByValue, onSortChange, listingPage, locale,
}) => ({
  sortByOptions,
  sortByValue,
  onSortChange,
  listingPage,
  locale,
})

export default WithTriangleUiContext(mapStateToProps)(memo(SortBy))
